module.exports = __webpack_public_path__ + "static/img/banner11.1780fd4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner11.jpeg
// module id = XpZ4
// module chunks = 2